import { Pipe, PipeTransform } from '@angular/core';
import { Labels } from './labels.service';

/**
 * Label Pipe - Use labels directly in templates
 * 
 * Usage:
 * ```html
 * <!-- Simple label -->
 * <button>{{ 'common.save' | label }}</button>
 * 
 * <!-- With parameters -->
 * <span>{{ 'validation.minLength' | label:5 }}</span>
 * 
 * <!-- Multiple parameters -->
 * <span>{{ 'errors.custom' | label:param1:param2 }}</span>
 * ```
 * 
 * Performance:
 * - Pure pipe (only recalculates when input changes)
 * - O(1) lookup from cached map
 */
@Pipe({
  name: 'label',
  pure: true,
  standalone: false
})
export class LabelPipe implements PipeTransform {
  transform(key: string, ...params: (string | number)[]): string {
    return Labels.get(key, ...params);
  }
}

/**
 * Label Exists Pipe - Check if a label key exists
 * 
 * Usage:
 * ```html
 * <span *ngIf="'custom.key' | labelExists">
 *   {{ 'custom.key' | label }}
 * </span>
 * ```
 */
@Pipe({
  name: 'labelExists',
  pure: true,
  standalone: false
})
export class LabelExistsPipe implements PipeTransform {
  transform(key: string): boolean {
    return Labels.has(key);
  }
}
